import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFetchBlog } from "../../../hooks/useFetchBlog";
import { renderBodyContent } from "../../../Component/renderBodyContent";

import AIheader from '../../RentAI/AIheader';
import Footer from '../../../Component/Footer/Footer';
import BlogFaq from "../../../Component/blog/BlogFaq/BlogFaq";
//import JoinPriorityWaitlistBtn from "../../../Component/ViralLoops/JoinPriorityWaitlistBtn";
import Getstarted from "../../../Component/GetStarted/Getstarted";




const BlogTemplate = () => {

  const [showGetstarted, setShowGetstared] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);



  const { slug } = useParams();
  const { blogData, loading } = useFetchBlog(slug);

  const dynamicMenuItems = blogData?.body_content
  ?.map((item, index) => {
    if (item.__component === "body-content.body-heading") {
      return {
        id: `heading-${index}`,
        text: item.h2_heading,
      };
    }
    return null;
  })
  .filter(Boolean); // remove nulls


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Adjust for offset
  
      let foundIndex = 0;
      dynamicMenuItems?.forEach((item, index) => {
        const section = document.getElementById(item.id);
        if (section) {
          const offsetTop = section.offsetTop;
          if (scrollPosition >= offsetTop) {
            foundIndex = index;
          }
        }
      });
  
      setActiveIndex(foundIndex);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dynamicMenuItems]);
  




  return (
    <>
      <AIheader />

      <Getstarted
      showJoinWaitList={showGetstarted}
      onClose={() => setShowGetstared(false)}
      onOpen={() => setShowGetstared(true)}
      />

      <section className="maxBannerMain identityBannerMain">
        <div className="bannerBlogOuter">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="maxBannerLeft">
                <div className="blogHeadingInner">
                                <img width="17px" src="/img/blog/blog_icon_blue.svg" alt="icon"/>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/blog-template">Blog</a></li>
                                        <img width="" src="/img/arrow-right-nav.svg" alt="arrow"/>
                                        <li className="breadcrumb-item active" aria-current="page">Article 003</li>
                                    </ol>
                                </nav>
                            </div>
                  <h2>{blogData?.title || "Loading..."}</h2>
                  <p>
                    Published: {blogData?.published_date ? new Date(blogData.published_date).toLocaleDateString() : "Loading..."}
                  </p>
                  <p>Estimated Reading Time: {blogData?.readingTime|| "..."} min</p>
                  <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>
                  {/* <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" /> */}
                </div>
              </div>
            </div>
          </div>
          <div className="maxBannerRight">
            <img src={blogData?.imageUrl || "/img/blog/identityBanner.webp"} alt="blog" />
          </div>
        </div>
      </section>

      <section className="choosePhotoMain">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
            <div className="choosePhotoLeft">
            {blogData?.body_content?.length > 0 && (
          <ul>
          {dynamicMenuItems.map((item, i) => (
            <li key={i} className={i === activeIndex ? "active" : ""}>
              <a href={`#${item.id}`}>{item.text}</a>
            </li>
          ))}
        </ul>
        
            )}
            </div>
            </div>
            <div className="col-lg-9">
              <div className="choosePhotoRight">
                {blogData?.description && <p>{blogData.description}</p>}
                {blogData?.body_content?.length > 0 && renderBodyContent(blogData.body_content)}
                
              </div>
              <BlogFaq />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogTemplate;
